import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Footer from '../cards/Footer';
import { getMarkDown, useDetectMobile, useDetectIOS, useDetectAndroid } from '../utils';
import '../../../stylesheets/triagebot/Dialog.scss';

const OdvvChangeOverDialog = ({ open, message, setOpen, onContinue, onCancel }) => {
    const { isMobile } = useDetectMobile();
    const { isIOS } = useDetectIOS();
    const { isAndroid } = useDetectAndroid();

    const headerText = message?.data?.[0]?.headerText || '';
    const continueButtonText = message?.data?.[0]?.nextButton?.displayText || 'Continue';
    const cancelButtonText = message?.data?.[0]?.cancelButton?.displayText || 'Cancel';

    const externalSchedulingUrl = message?.data?.[1]?.externalSchedulingUrl || '';

    let iosUrl = message?.data?.[1]?.iOSOdvvURL;
    let androidUrl = message?.data?.[1]?.androidOdvvURL;

    // If this is an eVisit deeplink payload with csn, construct platform URLs like ChangeOverDialog.
    try {
        if (externalSchedulingUrl) {
            const params = new URLSearchParams(new URL(externalSchedulingUrl).search);
            const isEVisit = params.has('csn');
            const csnValue = params.get('csn');

            if (isEVisit) {
                iosUrl = message?.data?.[1]?.iOSEvisitURL?.replace('${csnValue}', csnValue) || iosUrl;
                androidUrl = message?.data?.[1]?.androidEVisitURL?.replace('${csnValue}', csnValue) || androidUrl;
            }
        }
    } catch (e) {
        // keep fallbacks
    }

    const handleCloseOnly = () => {
        setOpen(false);
        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    };

    const handleCancel = () => {
        handleCloseOnly();
        onCancel?.();
    };

    const handleContinue = () => {
        // Requirement: open in new tab.
        let redirectUrl = externalSchedulingUrl;
        if (isIOS && iosUrl) redirectUrl = iosUrl;
        else if (isAndroid && androidUrl) redirectUrl = androidUrl;

        if (redirectUrl) {
            window.open(redirectUrl, '_blank', 'noopener,noreferrer');
        }

        handleCloseOnly();
        onContinue?.();
    };

    // Keep same visual sizing behavior as ChangeOverDialog.
    function getStyle(oElm, strCssRule) {
        var strValue = '';
        if (document.defaultView && document.defaultView.getComputedStyle) {
            strValue = document.defaultView.getComputedStyle(oElm, '').getPropertyValue(strCssRule);
        } else if (oElm.currentStyle) {
            strCssRule = strCssRule.replace(/-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    useEffect(() => {
        if (!open) return;
        setTimeout(() => {
            const cards = document.getElementsByClassName('turn');
            if (!cards.length) return;

            const cWidth = cards[cards.length - 1].offsetWidth;
            const dialog = document.querySelector('#odvv-change-dialog .MuiDialog-paper');
            if (!dialog) return;

            const padding = parseInt(getStyle(dialog, 'padding-left')) + parseInt(getStyle(dialog, 'padding-right'));
            dialog.style.width = cWidth - padding + 'px';
            dialog.style.minWidth = cWidth - padding + 'px';
        }, 1);
    }, [open]);

    useEffect(() => {
        if (!open) return;
        const element = document.getElementsByClassName('loader');
        if (element && element.length > 0) {
            element[0].style.visibility = 'hidden';
        }
    }, [open]);

    return (
        <Dialog id='odvv-change-dialog' open={open} onClose={handleCancel}>
            <div id='dialog-title'>
                <h2 className='headerText'>{getMarkDown(headerText)}</h2>
            </div>

            <DialogActions id='dialog-footer'>
                <Footer>
                    <button
                        className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                        onClick={handleCancel}
                    >
                        {cancelButtonText}
                    </button>
                    <button
                        className='continue-button'
                        onClick={handleContinue}
                    >
                        {continueButtonText}
                    </button>
                </Footer>
            </DialogActions>
        </Dialog>
    );
};

export default OdvvChangeOverDialog;